import BaseAPI from "@/api/BaseAPI";


export class SprAPI extends BaseAPI {
  constructor() {
    super('');
  }

  /**
   * @param {'founder'| 'region'} typeContact
   * */
  getFoundersOrRegionsInfo(typeContact) {
    if (typeContact === 'founder') { // TODO временно
      return this.http.get(`/${typeContact}`)
    } else {
      return this.http.get(`/${typeContact}/get`)
    }
  }

  getKcpGroups() {
    return this.http.get(`/spr/kcp/get`)
  }

  getUsls() {
    return this.http.get(`/spr/usl/get`)
  }

  getFo() {
    return this.http.get(`/spr/fo/get`)
  }

  getSpec() {
    return this.http.get(`/spr/spec/get`)
  }

  getOrgs() {
    return this.http.get(`/spr/org/get`, {data: {isHead: true}})
  }

  /**
   * @param {number} id ORG ownerId
   * */
  getOrgsByOwner(id) {
    return this.http.get(`/spr/org/byOwnerId/get`, {data: {ownerId: id}})
  }

  getIndicators() {
    return this.http.get(`/spr/allIndicators/get`)
  }

  getKcpUgs() {
    return this.http.get(`/spr/kcpUgs/get`)
  }

  getTypes() {
    return this.http.get(`/spr/org/type/get`)
  }

  getFounders() {
    return this.http.get(`/spr/founder/get`)
  }
}

export default new SprAPI()